module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMZJREFUKBWV0rENwjAQBdA7S84ATEFLTQsdXUJBwSYgIcESFEyA01HSUrNJBsASxj+RUTDxGSxZaf69O9shyqytKSfYmRixFADwdHxFRrGb7av6nsonoYA4ciMUM3EjYYNQH/HAA5AHCwn7gmLEB8oOolrCPqAh5LA0F0Cbc7VwlMbekIQAwpKwFvoF6ag0xjuzGltnb3gdXCzuJBwnFMffeDLNeqos2/U/CFA0QkM0Ri0Mpak4+b/kSErNc5P0J2uzvga1MF5cMpl2QP54GAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIQ/path.png
// module id = I2uT
// module chunks = 0